import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { ACHProcessorData } from "globalConstants";
import { getErrorMessage } from "helpers";
import { mapAchProcessorFromServer } from "mappers";
import { achProcessorService, dropdownValuesService } from "services";
import { merchantGeneralActions, uiActions } from "store";
import { ErrorResponse } from "types";

const useGetMerchantAchProcessorQuery = (merchantId: string) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["getMerchantAchProcessorData", merchantId],
		async () => {
			const data = await achProcessorService.getMerchantAchProcessor(
				merchantId,
			);

			const billingRouting =
				data?.[ACHProcessorData.BillingRouting.beName];

			if (billingRouting) {
				const body = {
					pattern: billingRouting,
					page: 0,
					pageSize: 20,
				};

				const banks = await dropdownValuesService.getBanks(body);
				await dispatch(
					merchantGeneralActions.setBillingBanks(banks?.items),
				);
			}

			return data;
		},
		{
			select(data: { [key: string]: any }) {
				return mapAchProcessorFromServer(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!merchantId,
		},
	);

	return queryResult;
};

export default useGetMerchantAchProcessorQuery;
